module.exports = __webpack_public_path__ + "static/media/style-persona-2.d4eee6f3.png";